import React from "react";
import Inspection from "./OverAll/Inspection";
import Ticket from "./OverAll/Ticket";
import Contracts from "./OverAll/contract";
import OverView from "./OverAll/OverView";
import Recent from "./OverAll/Recent";
import Upcoming from "./OverAll/Upcoming";
import Renewal from "./OverAll/Renewal";
import Client from "./OverAll/Client";
import OpenTicket from "./OverAll/OpenTicket";
import MonthlyWise from "./OverAll/MonthlyWise";
import InvoiceYear from "./OverAll/InvoiceYear";
import InvoiceDue from "./OverAll/InvoiceDue";
import OpenTask from "./OverAll/OpenTask";
import TestingCom from "./OverAll/TestingCom";
import Refilling from "./OverAll/Refilling";
import { GetAccess, GetUseRole } from "../../../Components/Utils/roles";
import OverViewTicklet from "./OverAll/TicketOverview";
import InpectionAllocation from "./OverAll/InpectionAllocation";

function Dashboard() {
  return (
    <div className="w-[100%] h-[calc(100vh-145px)] py-0.5  ">
    
{/* {(GetUseRole('super admin') || GetUseRole('admin') || GetUseRole('manager')) && (

      <div className="grid grid-cols-8  gap-4">
        <div className="col-span-8 md:col-span-4 lg:col-span-2">
            <Client />
          </div>        
        <div className="col-span-8 md:col-span-4 lg:col-span-2 lg:col-start-3">
            <Inspection />
          </div>        
        <div className="col-span-8 md:col-span-4 lg:col-span-2  lg:col-start-5">
            <Ticket />
          </div>        
        <div className="col-span-8 md:col-span-4 lg:col-span-2 lg:col-start-7">
            <Contracts />
          </div>        
        <div className="col-span-8 lg:col-span-5 ">
            <OverView />
          </div>        
        <div className="col-span-8 lg:col-span-3  lg:col-start-6 ">
            <Upcoming />
          </div>        
        <div className="col-span-8 lg:col-span-2  ">
            <OpenTask />
          </div>        
        <div className="col-span-8 lg:col-span-6  lg:col-start-3 ">
            <MonthlyWise />
          </div>        
        <div className="col-span-8 lg:col-span-3  ">
            <InvoiceYear />
          </div>        
        <div className="col-span-8 lg:col-span-5  lg:col-start-4 ">
            <InvoiceDue />
          </div>        
        <div className="col-span-8 lg:col-span-2  ">
            <OpenTicket />
          </div>        
        <div className="col-span-8 lg:col-span-4  lg:col-start-3 ">
            <TestingCom />
          </div>        
        <div className="col-span-8 lg:col-span-2  lg:col-start-7 ">
            <Refilling />
          </div>  
   </div>)} */}

{(GetUseRole('super admin') || GetUseRole('admin') || GetUseRole('manager')) && (
  <div className="grid grid-cols-1 md:grid-cols-8 gap-4">

    {/* Top Section */}
    <div className="col-span-1 md:col-span-8 flex flex-col lg:flex-row gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full lg:w-[38%]">
  <Client />
  <Inspection />
  <Ticket />
  <Contracts />
</div>

      <div className="w-full lg:w-[62%]">
        <InpectionAllocation />
      </div>
    </div>

    {/* Overview */}
    <div className="col-span-1 md:col-span-8 lg:col-span-5">
      <OverView />
    </div>

    {/* Upcoming */}
    <div className="col-span-1 md:col-span-8 lg:col-span-3 lg:col-start-6">
      <Upcoming />
    </div>

    {/* Open Task */}
    <div className="col-span-1 md:col-span-8 lg:col-span-2">
      <OpenTask />
    </div>

    {/* Monthly Wise */}
    <div className="col-span-1 md:col-span-8 lg:col-span-6 lg:col-start-3">
      <MonthlyWise />
    </div>

    {/* Invoice Year */}
    <div className="col-span-1 md:col-span-8 lg:col-span-3">
      <InvoiceYear />
    </div>

    {/* Invoice Due */}
    <div className="col-span-1 md:col-span-8 lg:col-span-5 lg:col-start-4">
      <InvoiceDue />
    </div>

    {/* Open Ticket */}
    <div className="col-span-1 md:col-span-8 lg:col-span-2">
      <OpenTicket />
    </div>

    {/* Testing */}
    <div className="col-span-1 md:col-span-8 lg:col-span-4 lg:col-start-3">
      <TestingCom />
    </div>

    {/* Refilling */}
    <div className="col-span-1 md:col-span-8 lg:col-span-2 lg:col-start-7">
      <Refilling />
    </div>
  </div>
)}


{GetUseRole("client") &&
          <div className="grid grid-cols-8  gap-4">
    <div className="col-span-2"><Inspection/></div>
    <div className="col-span-2 col-start-3"><Ticket/></div>
    <div className="col-span-4 col-start-5"><Refilling/></div>
    <div className="col-span-5 "><OverViewTicklet/></div>
    <div className="col-span-3  col-start-6 "><Upcoming/></div>
    <div className="col-span-3 "><InvoiceYear/></div>
    <div className="col-span-3 col-start-4 "><InvoiceDue/></div>
    <div className="col-span-2  col-start-7"><OpenTicket/></div>
</div>  }    
{(GetUseRole('inspector') || GetUseRole('supervisor') || GetUseRole('user')) && (
          <div className="grid grid-cols-8  gap-4">
     <div className="col-span-8 md:col-span-4 lg:col-span-2">
            <Client />
          </div>        
        <div className="col-span-8 md:col-span-4 lg:col-span-2 lg:col-start-3">
            <Inspection />
          </div>        
        <div className="col-span-8 md:col-span-4 lg:col-span-2  lg:col-start-5">
            <Ticket />
          </div>        
        <div className="col-span-8 md:col-span-4 lg:col-span-2 lg:col-start-7">
            <Contracts />
          </div>        
        <div className="col-span-8 lg:col-span-5 ">
            <OverView />
          </div>        
        <div className="col-span-8 lg:col-span-3  lg:col-start-6 ">
            <Upcoming />
          </div>        
        <div className="col-span-8 lg:col-span-2  ">
            <OpenTask />
          </div>        
        <div className="col-span-8 lg:col-span-6  lg:col-start-3 ">
            <MonthlyWise />
          </div>        
              
        <div className="col-span-8 lg:col-span-2  ">
            <OpenTicket />
          </div>        
        <div className="col-span-8 lg:col-span-4  lg:col-start-3 ">
            <TestingCom />
          </div>        
        <div className="col-span-8 lg:col-span-2  lg:col-start-7 ">
            <Refilling />
          </div>  
</div>  )}    
      </div>
  );
}

export default Dashboard;
